export const defaultEventName = 'dl_event';
export const defaultPageEventName = 'dl_page';
